import styled, { css } from "styled-components"

export default {
    "ModalBackground": styled.div`
        position: fixed;
        top: 0;
        left: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100vw;
        height: 100vh;
        background-color: rgba(0, 0, 0, 0.6);
        z-index: 50;

        ${({ $upper }) => $upper && css`
            z-index: 51;
        `}
    `,
    "Modal": styled.div`
        position: relative;
        width: 90vw;
        height: 90vh;
        display: flex;
        gap: 24px;
        display: flex;
        justify-content: center;
        align-items: center;

        & > img {
            width: 100%;
            height: 100%;
            object-fit: contain;
        }
    `,
    "CloseButton": styled.button`
        position: absolute;
        top: -48px;
        left: calc(50% - 16px);
        display: flex;
        background-color: rgba(0, 0, 0, 0.5);
        padding: 8px;
        border-radius: 50%;

        img {
            width: 16px;
        }
    `
}